export default "__VITE_ASSET__Bu2XW5T9__"